import React from "react";
import NumberUtils from "util/NumberUtils";
const SizeBasedRotationStrategySummary = ({ config }) => {
  const { max_size: maxSize } = config;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, "Index rotation strategy:"), /* @__PURE__ */ React.createElement("dd", null, "Index Size"), /* @__PURE__ */ React.createElement("dt", null, "Max index size:"), /* @__PURE__ */ React.createElement("dd", null, maxSize, " bytes (", NumberUtils.formatBytes(maxSize), ")")));
};
export default SizeBasedRotationStrategySummary;
